"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Table = /** @class */ (function () {
    function Table(head, body, columnsCount, rowsCount, columnsDepth, options) {
        this._head = head;
        this._body = body;
        this._columnsCount = columnsCount;
        this._rowsCount = rowsCount;
        this._columnsDepth = columnsDepth;
        this._options = options;
        this._lastRowTempNodeRemoved = false;
    }
    Object.defineProperty(Table.prototype, "head", {
        get: function () {
            return this._head;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Table.prototype, "body", {
        get: function () {
            return this._body;
        },
        set: function (value) {
            this._body = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Table.prototype, "columnsCount", {
        get: function () {
            return this._columnsCount;
        },
        set: function (value) {
            this._columnsCount = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Table.prototype, "rowsCount", {
        get: function () {
            return this._rowsCount;
        },
        set: function (value) {
            this._rowsCount = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Table.prototype, "columnsDepth", {
        get: function () {
            return this._columnsDepth;
        },
        set: function (value) {
            this._columnsDepth = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Table.prototype, "options", {
        get: function () {
            return this._options;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Table.prototype, "headShift", {
        get: function () {
            return this._headShift;
        },
        set: function (value) {
            this._headShift = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Table.prototype, "lastRowTempNodeRemoved", {
        get: function () {
            return this._lastRowTempNodeRemoved;
        },
        set: function (value) {
            this._lastRowTempNodeRemoved = value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Disable animation on table body rows.
     */
    Table.prototype.disableRowsAnimation = function () {
        for (var i = 0; i < this._body.length; i++) {
            this._body[i].animate = false;
        }
        this.options.options.forEach(function (value) { return value.animate = false; });
    };
    return Table;
}());
exports.Table = Table;
//# sourceMappingURL=table.js.map